import {Component} from '@angular/core';

@Component({
    templateUrl: './wrapper.component.html',
    styleUrls: ['./wrapper.component.scss'],
    standalone: false
})
export class InstatekaWrapperComponent {

}
